import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
export default {
    methods: {
        /*支付，寄送*/
        getPay(type) {
            let Params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                ParmType: type
            }
            GetParmConfig(Params).then(res => {
                util.doResult(this, res, () => {
                    if (type == 9) {
                        this.PayList = res.data.Data;
                    } else {
                        this.transportList = res.data.Data;
                    }

                });
            });
        },
        // 查看/修改
        getList(orderId) {

            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            this.loading = true;
            this.GoodsListNum = []
            $http.get("api/ContinueOrder/GetContinueOrderById", params).then(res => {
                jToast.close();
                this.AddDialogVisible = true;
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form = util.filterAndSetData(this.form, Data) //过滤数据

                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo
                    //收货地址
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress
                    //联系人及电话
                    this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel

                    this.ZqwPlatform_GetClassList(this.form.SchoolId)
                    this.ClassNum = Data.ClassNum //存储开班数数据
                    this.PayObjectId = Data.PayObject //存储支付对象
                    this.ClassId = Data.ClassId //存储班级ID
                    let listPackage = Data.ProList[0].List
                    if (Data.PackageId == 402 || Data.PackageId == 401 || Data.PackageId == 399 || Data.PackageId == 5042) {
                        //全园续

                        for (let i = 0; i < listPackage.length; i++) {
                            for (let j = 0; j < this.Packages.length; j++) {

                                if (listPackage[i].ProId == this.Packages[j].ProId) {

                                    this.Packages[j].ProNum = listPackage[i].ProNum
                                }
                            }
                        }
                        this.boxData = cloneDeep(this.Packages) //存储数据下发的

                    } else {
                        this.GoodsListNum = cloneDeep(Data.ProList)
                        if (Data.PackageId == 405) {
                            for (let i = 0; i < this.GoodsListNum.length; i++) {
                                this.GoodsListNum[i].List[0].title = '配置美师英语学习材料包'
                                this.GoodsListNum[i].List[1].title = '配置思维导图学习材料包'
                                this.GoodsListNum[i].List[2].title = '配置艺术亲子活动材料包'
                            }
                            this.boxData = this.GoodsListNum //存储数据下发的
                        } else {
                            this.boxData = cloneDeep(Data.ProList) //存储数据下发的
                        }
                    }
                    this.schoolConsignee.Consignee = Data.SchoolConsignee
                    this.schoolConsignee.ConsigneeAddress = Data.SchoolAddress
                    this.schoolConsignee.ConsigneeAreaId = Data.SchoolAreaId
                    this.schoolConsignee.ConsigneeCityId = Data.SchoolCityId
                    this.schoolConsignee.ConsigneeProvId = Data.SchoolProvincesId
                    this.schoolConsignee.ConsigneeTel = Data.SchoolConsigneeTel
                    this.payList = Data.ListMeetPay
                });
            });
        },
        //获取班级列表 api/Class/ZqwPlatform_GetClassList
        ZqwPlatform_GetClassList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };

            $http.get("api/Class/ZqwPlatform_GetClassList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                util.doResult(this, res, () => {
                    this.ClassLists = Data

                    //this.openClassList[0].ClassLists = Data
                    this.openClassList = []
                    if (this.form.ClassList.length > 0) {
                        // 获取单条赋值
                        for (let i = 0; i < this.form.ClassNum; i++) {
                            this.openClassList.push({
                                ClassId: this.form.ClassList[i].ClassId,
                                ClassLists: this.ClassLists
                            })
                        }
                    } else {
                        for (let i = 0; i < this.form.ClassNum; i++) {
                            this.openClassList.push({
                                ClassId: '',
                                ClassLists: this.ClassLists
                            })
                        }
                    }


                });
            });
        },
        // 获取收货地址
        getSchoolConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                schoolId: id
            };
            this.loading = true;
            $http.get("api/School/GetSchoolConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.SchoolConsigneeList = Data;
                    for (let i = 0; i < this.SchoolConsigneeList.length; i++) {
                        //IsDefault==1为默认地址
                        if (this.SchoolConsigneeList[i].IsDefault == 1) {
                            this.ConsigneeList = this.SchoolConsigneeList[i].ConsigneeProvinceName + '  ' + this.SchoolConsigneeList[i].ConsigneeCityName + '  ' + this.SchoolConsigneeList[i].ConsigneeAreaName + '  ' + this.SchoolConsigneeList[i].ConsigneeAdress
                            this.ConsigneeListName = this.SchoolConsigneeList[i].Consignee + '  ' + this.SchoolConsigneeList[i].ConsigneeTel
                            this.form.SchoolConsigneeId = this.SchoolConsigneeList[i].Id

                            //设置地址
                            this.schoolConsignee.ConsigneeProvId = this.SchoolConsigneeList[i].ConsigneeProvince
                            this.schoolConsignee.ConsigneeCityId = this.SchoolConsigneeList[i].ConsigneeCity
                            this.schoolConsignee.ConsigneeAreaId = this.SchoolConsigneeList[i].ConsigneeArea
                            this.schoolConsignee.ConsigneeAddress = this.SchoolConsigneeList[i].ConsigneeAdress
                            this.schoolConsignee.Consignee = this.SchoolConsigneeList[i].Consignee
                            this.schoolConsignee.ConsigneeTel = this.SchoolConsigneeList[i].ConsigneeTel
                        }
                    }
                });
            });
        },
        //新增
        getAddOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/ContinueOrder/ContinueOrderAdd", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '添加成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.closeFn()

                });
            });
        },
        //修改
        getUpdateOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/ContinueOrder/ContinueOrderUpdate", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.closeFn()
                });
            });
        },
        // 获取续班套餐
        getPackages(agentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: agentId,
            };
            this.loading = true;
            $http.get("api/Common/GetAgentProjectType", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                this.ProjectTypes = []
                util.doResult(this, res, () => {
                    if (Data.ProjectType == 2) {
                        this.ProjectTypes = [{
                            ProjectType: 2,
                            ProjectTypeName: "hi幼教"
                        }];
                    } else if (Data.ProjectType == 1) {
                        this.ProjectTypes = [{
                            ProjectType: 1,
                            ProjectTypeName: "联帮在线"
                        }];
                    } else {
                        // 2 hi幼教，1 联帮在线都有
                        this.ProjectTypes = [{
                            ProjectType: 2,
                            ProjectTypeName: "hi幼教"
                        }, {
                            ProjectType: 1,
                            ProjectTypeName: "联帮在线"
                        }];
                    }

                });
            });
        },
        // 获取亲子活动班级列表
        getClassId(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: id,
            };
            this.classList = []
            $http.get("api/ContinueOrder/GetClassBySchoolId", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.classList = Data

            });
        },
        // 获取续班的套餐
        getContinuePackages(SchoolId, ProjectType) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                SchoolId: SchoolId,
                ProjectTypes: ProjectType
            };
            this.loading = true;
            if (this.form.OrderId !== 0) {
                params.OrderId = this.form.OrderId
            }
            $http.get("api/ContinueOrder/GetContinuePackageListEx", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.showData.PreSemesterClasNum = Data.PreSemesterClasNum
                    this.showData.ContinueClassNum = Data.ContinueClassNum
                    this.showData.OverNum = Data.OverNum
                    this.showData.lessClassNum = this.showData.ContinueClassNum - this.showData.PreSemesterClasNum
                    // if (Data.AuditingPassingNum > 0) {
                    //     this.$notify({
                    //         title: '警告',
                    //         message: '该园所存在正在审核的续班订单，无法进行下单，请切换园所！',
                    //         type: 'warning'
                    //     });
                    // }

                    this.ContinuePackages = Data.ListPackage
                });
            });
        },
        // 获取套餐资源包下拉明细
        getDetailsPackage(PackageId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                PackageId: PackageId,
            };
            this.loading = true;
            if (PackageId == 0) {
                return
            }
            $http.get("api/ContinueOrder/GetPackageDetailById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                this.Packages = []
                util.doResult(this, res, () => {
                    this.detailsPackages = Data //其余资源包下拉
                    if (PackageId == 405) {
                        // 套餐三续资源包
                        for (let num = 0; num <= 3; num++) {
                            this.package3Details[num] = []
                        }
                        for (let i = 0; i < this.detailsPackages.length; i++) {
                            if (this.detailsPackages[i].SubjectId == 94) {
                                // 美师
                                this.package3Details[0].push(this.detailsPackages[i])
                            } else if (this.detailsPackages[i].SubjectId == 97) {
                                // 思维
                                this.package3Details[1].push(this.detailsPackages[i])
                            } else {
                                // 艺术
                                this.package3Details[2].push(this.detailsPackages[i])
                            }
                        }
                    } else if (this.form.ProjectType == 2) {
                        // Hi A B C 资源包 表格显示
                        let len = Data.length

                        for (let i = 0; i < len; i++) {
                            this.Packages.push({
                                ProId: 0,
                                ProNickName: "",
                                ProNum: 0
                            })
                            this.Packages[i].ProId = Data[i].ProId
                            this.Packages[i].ProNickName = Data[i].ProName

                        }
                    }

                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/BookPackage/ContinueOrderDialog/services.js